import { Globe, Lock, Cog, Timer, Database, Zap } from 'lucide-react';

// One customer-facing registry for Replov's six native service types. Backend
// validation remains authoritative; Batch 6 adds a backend-owned contract that
// verifies this metadata automatically.
export const CORE_SERVICE_TYPES = [
  {
    id: 'web',
    label: 'Web Service',
    name: 'Web Service',
    description: 'Public web apps and APIs with managed HTTPS',
    menuDescription: 'Node.js, Python, Docker, or another web runtime',
    pricingDescription: 'Public HTTP endpoints through regional Traefik ingress',
    examples: ['REST APIs', 'Full-stack apps', 'Next.js', 'Django'],
    icon: Zap,
    color: 'text-indigo',
    bg: 'bg-indigo/10',
    needsProject: true,
    minimumPlan: 'nano',
  },
  {
    id: 'static',
    label: 'Static Site',
    name: 'Static Site',
    description: 'Static websites built into an Nginx container with managed HTTPS',
    menuDescription: 'HTML, React, Vue, Angular, Astro, or Flutter Web',
    pricingDescription: 'Regional Nginx hosting through managed Traefik ingress',
    examples: ['HTML', 'React/Vite', 'Vue', 'Flutter Web'],
    icon: Globe,
    color: 'text-green',
    bg: 'bg-green/10',
    includedWithPlan: true,
    needsProject: true,
    minimumPlan: 'nano',
  },
  {
    id: 'private',
    label: 'Private Service',
    name: 'Private Service',
    description: 'Internal services reachable only from an attached private network',
    menuDescription: 'Internal APIs and private microservices without a public URL',
    pricingDescription: 'Private-network compute with no public route',
    examples: ['Internal APIs', 'Microservices', 'Private backends'],
    icon: Lock,
    color: 'text-purple',
    bg: 'bg-purple/10',
    needsProject: true,
    minimumPlan: 'nano',
  },
  {
    id: 'worker',
    label: 'Background Worker',
    name: 'Background Worker',
    description: 'Continuously running background jobs',
    menuDescription: 'Long-running queue consumers and background jobs',
    pricingDescription: 'Continuous processing without a public route',
    examples: ['Queue consumers', 'Email workers', 'Data processing'],
    icon: Cog,
    color: 'text-amber',
    bg: 'bg-amber/10',
    needsProject: true,
    minimumPlan: 'nano',
  },
  {
    id: 'cron',
    label: 'Cron Job',
    name: 'Cron Job',
    description: 'Run a repository command on a schedule, then stop',
    menuDescription: 'Timezone-aware reports, cleanup, and one-off repository scripts',
    pricingDescription: 'Scheduled one-shot tasks using your repository image',
    examples: ['Reports', 'Cleanup', 'Scheduled scripts'],
    icon: Timer,
    color: 'text-pink',
    bg: 'bg-pink/10',
    needsProject: true,
    needsSchedule: true,
    minimumPlan: 'nano',
  },
  {
    id: 'redis',
    label: 'Redis Datastore',
    name: 'Redis Datastore',
    description: "Persistent managed Redis on your project's private network",
    menuDescription: "Managed Redis on your project's private network",
    pricingDescription: 'Persistent Redis datastore at the same tier prices as any service; starts at Micro',
    examples: ['Caching', 'Queues', 'Sessions', 'Rate limits'],
    icon: Database,
    color: 'text-red',
    bg: 'bg-red/10',
    needsProject: true,
    minimumPlan: 'micro',
  },
];

export const CORE_SERVICE_TYPE_IDS = CORE_SERVICE_TYPES.map(type => type.id);

export function getServiceType(typeId) {
  return CORE_SERVICE_TYPES.find(type => type.id === typeId) || null;
}
